export const FIELDS = [
  {
    label: "Title",
    register: "title",
  },
  {
    label: "ShortName",
    register: "shortName",
  },
  {
    label: "City",
    register: "city",
  },
  {
    label: "StreetAddress",
    register: "streetAddress",
  },
  {
    label: "ZipCode",
    register: "zipCode",
  },
  {
    label: "PhoneNumber",
    register: "phoneNumber",
  },
  {
    label: "Email",
    register: "email",
  },
];
